<template>
  <div class="popup" v-if="showModal">
    <div class="popup-body special-scroll special-scroll-dark">
      <h3 class="text-right">בחר מועמד</h3>
      <input v-model="query" type="text" placeholder="חיפוש לפי שם">
      <div class="row">
        <div :key="'fp-'+k" class="col-6 my-1" v-for="(p,k) in filteredPlayers">
          <img @click="() => addExistingPlayer(p)" width="100%" height="auto" :src="p.img">
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <button class="btn btn-danger btn-block" @click="close">סגור</button>
        </div>
        <div class="col-8">
          <button class="btn btn-success btn-block" @click="addPlayer">מתמודד חדש</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchModal",
  props: ['showModal', 'players', 'categoryPlayers'],
  data() {
    return {
      query: ''
    }
  },
  methods: {
    addExistingPlayer(player) {
      this.$emit('addExistingPlayer', player);
    },
    close() {
      this.$emit('closeSearch');
    },
    addPlayer() {
      this.$emit('addPlayer');
    },
  },
  computed: {
    filteredPlayers() {
      return this.players.filter(p => !this.categoryPlayers.includes(p.id) && (!this.query || p.name.includes(this.query))).slice(0, Math.min(this.players.length, 4))
    }
  }
}
</script>

<style scoped lang="scss">
.popup {

}

h3 {
  margin: 20px 0;
}

.disabled {
  pointer-events: none;
  opacity: .75;
}


</style>
